import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ChevronRight, Home, Loader2 } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { documentsApi } from '../../../lib/api/documentsApi.connect';
/**
 * Resolves the parent chain of a folder and renders a clickable
 * "Root › Projects › Q1" trail. Walks one getFolder call per ancestor — fine
 * because tenants keep folder depth shallow in practice and this is only on
 * the list page.
 */ export function Breadcrumbs({ folderId }) {
    const [trail, setTrail] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(()=>{
        if (!folderId) {
            setTrail([]);
            return;
        }
        let cancelled = false;
        setLoading(true);
        (async ()=>{
            const chain = [];
            let cursor = folderId;
            try {
                while(cursor){
                    const f = await documentsApi.getFolder(cursor);
                    chain.unshift(f);
                    cursor = f.parentId;
                }
            } catch  {
            // Fall through — we'll show whatever we managed to resolve.
            }
            if (!cancelled) {
                setTrail(chain);
                setLoading(false);
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        folderId
    ]);
    if (!folderId) return null;
    return /*#__PURE__*/ _jsxs("nav", {
        "aria-label": "Folder path",
        className: "flex items-center gap-1 text-xs text-muted-foreground mt-2 flex-wrap",
        children: [
            /*#__PURE__*/ _jsxs(Link, {
                to: "/editor",
                className: "inline-flex items-center gap-1 hover:text-foreground",
                children: [
                    /*#__PURE__*/ _jsx(Home, {
                        className: "w-3 h-3"
                    }),
                    " Root"
                ]
            }),
            loading && trail.length === 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(ChevronRight, {
                        className: "w-3 h-3"
                    }),
                    /*#__PURE__*/ _jsx(Loader2, {
                        className: "w-3 h-3 animate-spin"
                    })
                ]
            }) : trail.map((f, i)=>/*#__PURE__*/ _jsxs("span", {
                    className: "flex items-center gap-1",
                    children: [
                        /*#__PURE__*/ _jsx(ChevronRight, {
                            className: "w-3 h-3"
                        }),
                        i === trail.length - 1 ? /*#__PURE__*/ _jsx("span", {
                            className: "text-foreground font-medium",
                            children: f.name
                        }) : /*#__PURE__*/ _jsx(Link, {
                            to: `/editor/folder/${f.id}`,
                            className: "hover:text-foreground",
                            children: f.name
                        })
                    ]
                }, f.id))
        ]
    });
}
